import { createContext, useCallback, useContext, useMemo } from "react";
import { usePoll } from "./api";

const Ctx = createContext(null);

export function DataProvider({ children }) {
  const items = usePoll("/items");
  const boms = usePoll("/boms");
  const suppliers = usePoll("/suppliers");
  const ordering = usePoll("/ordering/required/summary", 15000);
  const plans = usePoll("/planning/plans/summary", 15000);
  const policy = usePoll("/policy", 30000);

  const refreshAll = useCallback(() => Promise.all([items.refresh(), boms.refresh(), suppliers.refresh()]), [items, boms, suppliers]);

  const value = useMemo(() => {
    const list = (items.data || []).filter((i) => !i.inactive);
    const byId = Object.fromEntries((items.data || []).map((i) => [i.id, i]));
    return {
      items: list, allItems: items.data || [], itemsById: byId, boms: boms.data || [], suppliers: suppliers.data || [],
      loading: !items.data, error: items.error || boms.error,
      lastSync: items.lastSync, syncing: items.syncing, refreshAll, ordering: ordering.data, plans: plans.data, refreshPlans: plans.refresh, policy: policy.data, refreshPolicy: policy.refresh,
    };
  }, [items.data, items.error, items.lastSync, items.syncing, boms.data, boms.error, suppliers.data, refreshAll, ordering.data, plans.data, plans.refresh, policy.data, policy.refresh]);

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useData = () => useContext(Ctx);
